(ns motorsaif.web.pages.ops.components
  (:require
   ["react-transition-group" :refer [CSSTransition SwitchTransition]]
   [motorsaif.web.online-state :as online-state]
   [motorsaif.constants :as constants]
   [goog.string :refer [format]]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.time :as time]
   [motorsaif.request-utils :as request-utils]
   [motorsaif.url :as url]
   [motorsaif.shared.chat :as shared-chat]
   [motorsaif.shared.ops :as shared-ops]
   [motorsaif.utils :as utils]
   [motorsaif.web.components :as c]
   [motorsaif.web.components.chat :as chat]
   [motorsaif.web.photos :as photos]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   [reagent.core :as r]
   [reagent.ratom :as ra]
   [taoensso.encore :as encore]))


(defn- msg-content-preview
  "Return text or media"
  [{:keys [thread request current-owner-id] :as ff}]
  ;; (assert (seq interaction-statuses))
  ;; (def (keys zeh) ff)
  (let [{:keys [messages touches participants]} thread
        {:message/keys [body from media]
         last-ts :date-time/created} (shared-ops/last-msg messages)
        ;; current-owner-id @(subscribe [:current-owner-id])
        ack true

        {{request-type :db/ident} :request/type} request
        from-id (:db/id from)
        from-current-user? (= current-owner-id from-id)
        other-participant (shared-chat/other-participant {:thread thread
                                                          :request request
                                                          :current-owner-id current-owner-id})
        other-participant-id (:db/id other-participant)
        last-access (get-in touches [other-participant-id :touched/last-access])
        seen? (when last-access (time/after? last-access last-ts))
        ]

    [:div.content-preview
     (when media
       [:div.last-media
        (into [:div.photo-grid
               {:class (str "n-" (count media))}]
              (map (fn [itm]
                     (let [{media-id :db/id} itm
                           src (url/uploaded-media {:media itm
                                                    :size :med})]
                       ^{:key media-id}
                       [:div.media-item
                        [:img {:src src}]]))) media)

        (tr [:page.messages.media] [(count media)])])

     (when body [:div.last-msg
                 [:span.body
                  [:span.sender
                   (if from-current-user?
                     "You: "
                     "Them: ")] body]
                 (when from-current-user?
                   [:span.tick-status
                    (cond
                      (and ack seen?)
                      [:span.read-receipt
                       [:i.fa-regular.fa-check]
                       [:i.fa-regular.fa-check]]
                      ack
                      [:span.message-ack
                       [:i.fa-regular.fa-check]])])])]))

(defn preview-item [{:keys [request-id thread-id request thread] :as params}]
  (let [{created :date-time/created
         id :db/id
         short-id :short/id
         owner :owner
         :request/keys [object media description category]} request
        {:car/keys [year make model]} object
        {:keys [interaction-statuses]} thread
        category (:tag/title category)
        last-msg (shared-ops/last-msg (:messages thread))
        unread-count (count @(subscribe [:unread-responder-messages request-id]))
        img (photos/thumbnail-src request)
        ;; unread-count 9
        request-type-kw (get-in request [:request/type :db/ident])
        request-type (utils/request-type->str request-type-kw)

        last-interaction-status (request-utils/last-interaction-status interaction-statuses)

        status-options (get constants/interaction-status request-type-kw)
        current-status (or (:label last-interaction-status)
                           "Introduction")

        {:keys [label badge-class indicator] :as status-data}
        (first (filter #(= (:label %) current-status) status-options))
        
        time-info (shared-ops/time-remaining-text last-interaction-status status-data)

        [request-id owner-id] thread-id]
    [:a.preview-item
     {:href (routes/path-for :ops-chat {:request-id request-id
                                        :owner-id owner-id})}
     [:div.content
      {:class (utils/cond-css
               img "with-img")}
      (when img
        [:img {:src img}])
      [:div.info
       [c/avatar-letter-with-handle {:owner owner
                                     :letter-class "xs"}]
       [:div.car (format "%s %s %s" year make model)]
       [:div
        [:span.short-id short-id]
        [:span.tag.request-type request-type]]]]
     [:div.desc
      ;; [:span.title "Request Description"]
      [:p description]]
     ;; [:div.request-category.tag.primary category]
     [msg-content-preview
      (assoc params :current-owner-id @(subscribe [:current-owner-id]))]
     [:div.status
      [:div.left
       [:div.interaction-status.warning
        {:class badge-class}
        label
        ]]
      [:div.right
       (when (> unread-count 0)
         [:span.unread.circle
          (format "%s" unread-count)])
       (when time-info
         [:div.time-info {:class (:class time-info)}
          (:text time-info)])]]]))

(def categories
  [
   {:title "Leads"
    :desc "New conversations & inquiries"
    :category :leads
    :icon [:i.fa-solid.fa-user-plus]
    }
   {:title "Past Deadline"
    :desc "Overdue tasks need attention"
    :category :past-deadline
    :icon [:i.fa-solid.fa-triangle-exclamation]
    }
   {:title "Urgent"
    :desc "Approaching deadline soon"
    :category :urgent
    :icon [:i.fa-solid.fa-triangle-exclamation]
    }
   {:title "Needs Attention"
    :desc "Customer waiting for response"
    :category :attention
    :icon [:i.fa-solid.fa-triangle-exclamation]
    }
   {:title "In Progress"
    :desc "Active repairs & sourcing"
    :category :progress
    :icon [:i.fa-solid.fa-gear]
    }
   {:title "Waiting on Customer"
    :desc "Payments & approvals needed"
    :category :waiting
    :icon [:i.fa-solid.fa-clock]
    }
   {:title "All Conversations"
    :desc "Complete overview of requests"
    :category :all
    :icon [:i.fa-solid.fa-list]}])
